import React from 'react';
import { DomUtils, NoResults, NoResultsImage, Scrollbars } from '@onsolve/onsolve-ui-components';
import { sharedTranslations } from 'translations';
import RecentSearches from './RecentSearches/RecentSearches';
import Ring from './Utils/ring';
import SearchModal from './Search/SearchModal';
import SearchSuggestions from './Search/SearchSuggestions';
import SearchResultsList from './Search/SearchResultsList';
import { SidebarSearchService, addNewSearchToHistory } from './Services/SearchService';
import keyCodes from 'utils/keyCodes';
const globalSearchState = {
    suggestionState: 1,
    resultState: 2,
};
const initialState = {
    resultsByTerms: [],
    query: '',
    currentSearchState: globalSearchState.suggestionState,
    showFooterNavigation: false,
    isSelected: false,
};
class GlobalSearch extends React.Component {
    recentSearchesRef;
    searchModal;
    closeButton;
    clearRecent;
    ring;
    timer;
    searchService;
    constructor(props) {
        super(props);
        this.recentSearchesRef = React.createRef();
        this.searchModal = React.createRef();
        this.closeButton = React.createRef();
        this.clearRecent = React.createRef();
        this.ring = new Ring({ step: 1 });
        this.state = initialState;
        this.timer = null;
        this.handleUpKey = this.handleUpKey.bind(this);
        this.handleDownKey = this.handleDownKey.bind(this);
        this.handleInputFocus = this.handleInputFocus.bind(this);
    }
    componentDidUpdate(prevProps) {
        const { isOpen, sideBarMenuItems, intl: { messages }, access, getFeature, } = this.props;
        if (!prevProps.isOpen && isOpen) {
            this.searchService = new SidebarSearchService(sideBarMenuItems, messages, access, getFeature);
        }
    }
    focusOnSearchInput = () => {
        this.searchModal.current.focusInput();
    };
    handleInputChange = (e) => {
        const query = e.target.value;
        const { currentSearchState } = this.state;
        if (currentSearchState === globalSearchState.resultState) {
            this.setState({ query });
        }
        else {
            this.searchSuggestions(query);
        }
    };
    searchSuggestions = (query) => {
        const { resultsByTerms } = this.searchService.search(query);
        const showFooterNavigation = resultsByTerms.length > 0;
        this.ring.elements = this.getResultIds(resultsByTerms);
        this.setState({ resultsByTerms, query, showFooterNavigation });
    };
    searchWithRelatedTerms = (query) => {
        const { resultsByTerms, relatedTerm } = this.searchService.search(query, true);
        const showFooterNavigation = resultsByTerms.length > 0;
        this.ring.elements = this.getResultIds(resultsByTerms);
        this.setState({
            resultsByTerms,
            relatedTerm,
            query,
            currentSearchState: globalSearchState.resultState,
            showFooterNavigation,
        }, () => {
            this.saveRecentSearch();
            this.focusOnSearchInput();
        });
    };
    handleItemClick = (itemTitle) => {
        this.searchWithRelatedTerms(itemTitle);
    };
    handleSearchResultClick = (item) => {
        document.body.classList.remove('user-is-tabbing');
        const { history } = this.props;
        const { isEnabled = true, menuType, routeTo, redirectTo, newNav } = item;
        if (this.timer) {
            clearTimeout(this.timer);
        }
        if ((!menuType || (menuType && newNav)) && isEnabled && !redirectTo) {
            history.push(routeTo);
        }
        this.handleModalClose();
    };
    getResultIds = (resultsByTerms) => resultsByTerms.flatMap((item) => item.results).map((item) => item.id);
    handleKeyDown = (e, selectFirst) => {
        const { keyCode, shiftKey, currentTarget } = e;
        const { ENTER_KEY, TAB, UP, DOWN } = keyCodes;
        const { current } = this.recentSearchesRef;
        const { query, currentSearchState } = this.state;
        switch (keyCode) {
            case ENTER_KEY:
                document.body.classList.remove('user-is-tabbing');
                if (!query) {
                    this.setState({
                        currentSearchState: globalSearchState.suggestionState,
                    });
                }
                else if (!(document.activeElement.tagName === 'BUTTON' && document.activeElement.className === 'close')) {
                    this.searchWithRelatedTerms(query);
                }
                break;
            case UP:
                document.body.classList.remove('user-is-tabbing');
                e.preventDefault();
                if (current) {
                    current.selectLastElement();
                    break;
                }
                this.selectLastElement();
                break;
            case DOWN:
                document.body.classList.remove('user-is-tabbing');
                e.preventDefault();
                if (current) {
                    current.selectFirstElement();
                    break;
                }
                this.selectFirstElement();
                break;
            case shiftKey && TAB:
                if (currentTarget.classList.contains('onsolve-menu-search-field__input')) {
                    if (!query && currentSearchState === 1) {
                        current.selectLastElementsTrash();
                    }
                    else {
                        this.selectLastElement();
                    }
                }
                break;
            case TAB:
                this.addUserTabbing();
                e.preventDefault();
                if (selectFirst) {
                    if (!query && currentSearchState === 1) {
                        DomUtils.setFocus(this.clearRecent);
                        break;
                    }
                    if (current) {
                        current.selectFirstElement();
                        break;
                    }
                    this.selectFirstElement();
                    break;
                }
                setTimeout(() => {
                    DomUtils.setFocus(this.closeButton.current.elementRef);
                }, 0);
                break;
        }
    };
    saveRecentSearch = () => {
        const { query } = this.state;
        const { userId } = this.props;
        if (query.trim()) {
            addNewSearchToHistory(userId, query);
        }
    };
    handleModalClose = () => {
        this.setState(initialState);
        this.searchService = null;
        this.props.onClose();
    };
    handleInputFocus() {
        if (this.recentSearchesRef.current) {
            this.recentSearchesRef.current.unselectItems();
            return;
        }
        this.setState({ isSelected: false });
    }
    handleUpKey({ isTabbing }) {
        if (!isTabbing) {
            document.body.classList.remove('user-is-tabbing');
        }
        else {
            this.addUserTabbing();
        }
        if (this.ring.currentIndex === 0 && isTabbing) {
            this.setState({ currentElement: null, isSelected: false });
            DomUtils.setFocus(this.closeButton.current.elementRef);
            return false;
        }
        else {
            this.ring.previous();
            this.setState({ currentElement: this.ring.currentElement, isSelected: true });
        }
    }
    addUserTabbing() {
        if (!document.body.classList.contains('user-is-tabbing')) {
            document.body.classList.add('user-is-tabbing');
        }
    }
    handleTabKey = () => {
        this.addUserTabbing();
        if (this.ring.isLast) {
            this.focusOnSearchInput();
            return;
        }
        this.handleDownKey({ isTabbing: true });
    };
    handleDownKey({ isTabbing }) {
        if (!isTabbing) {
            document.body.classList.remove('user-is-tabbing');
        }
        this.ring.next();
        this.setState({ currentElement: this.ring.currentElement, isSelected: true });
    }
    handleTabOnClearRecent = () => {
        this.addUserTabbing();
        const { current } = this.recentSearchesRef;
        current.selectFirstElement();
    };
    selectLastElement() {
        this.ring.updateCurrent(this.ring._ringPower - 1);
        this.setState({ currentElement: this.ring.currentElement, isSelected: true });
    }
    selectFirstElement() {
        this.ring.updateCurrent(0);
        this.setState({ currentElement: this.ring.currentElement, isSelected: true });
    }
    updateFooter = (showFooterNavigation) => {
        this.setState({
            showFooterNavigation,
        });
    };
    getNoResults = () => {
        const { intl: { messages }, } = this.props;
        const noResultsImage = <NoResultsImage />;
        const noResultsTitle = messages.data[sharedTranslations.ng_generic_noResultsTitle.id];
        const noResultsDescription = messages.data[sharedTranslations.ng_generic_noResultsDescription.id];
        return (<div className="onsolve-menu-search__no-results">
                <NoResults image={noResultsImage} title={noResultsTitle} description={noResultsDescription}/>
            </div>);
    };
    getSearchResults = () => {
        const { resultsByTerms, relatedTerm, currentElement, isSelected } = this.state;
        const { intl: { messages }, } = this.props;
        return (<Scrollbars autoHeight autoHeightMax="28rem">
                <SearchResultsList onUpKey={this.handleUpKey} onDownKey={this.handleDownKey} onShiftTabKey={() => this.handleUpKey({ isTabbing: true })} onTabKey={this.handleTabKey} isSelected={isSelected} searchResults={resultsByTerms} relatedTerm={relatedTerm} selectedId={currentElement} onSearchSelection={this.handleSearchResultClick} intl={messages}/>
            </Scrollbars>);
    };
    getSearchSuggestions = () => {
        const { resultsByTerms, currentElement, isSelected } = this.state;
        return (<Scrollbars autoHeight autoHeightMax="28rem">
                <SearchSuggestions suggestions={resultsByTerms} onItemClick={this.handleItemClick} selectedId={currentElement} isSelected={isSelected} onUpKey={this.handleUpKey} onDownKey={this.handleDownKey} onShiftTabKey={() => this.handleUpKey({ isTabbing: true })} onTabKey={this.handleTabKey}/>
            </Scrollbars>);
    };
    getRecentSearches = () => {
        const { intl: { messages }, } = this.props;
        return (<RecentSearches updateFooter={this.updateFooter} forwardedClearRecentRef={this.clearRecent} onItemClick={this.handleItemClick} userId={this.props.userId} onUpKey={this.handleUpKey} onDownKey={this.handleDownKey} onShiftTabKey={this.handleUpKey} onTabKey={this.handleTabKey} onTabClick={this.handleTabOnClearRecent} ref={this.recentSearchesRef} addUserTabbing={this.addUserTabbing} focusOnSearchInput={this.focusOnSearchInput} intl={messages}/>);
    };
    getModalContent = () => {
        const { currentSearchState, resultsByTerms, query } = this.state;
        if (currentSearchState === globalSearchState.resultState) {
            return resultsByTerms.length ? this.getSearchResults() : this.getNoResults();
        }
        if (query) {
            return this.getSearchSuggestions();
        }
        return this.getRecentSearches();
    };
    render() {
        const { isOpen, intl: { messages }, } = this.props;
        const { query, showFooterNavigation } = this.state;
        const content = this.getModalContent();
        return (<SearchModal isOpen={isOpen} forwardedRef={this.searchModal} forwardedCloseRef={this.closeButton} onClose={this.handleModalClose} onFocus={this.handleInputFocus} onInputChange={this.handleInputChange} onKeyDown={this.handleKeyDown} value={query} content={content} withNavigation={showFooterNavigation} intl={messages}/>);
    }
}
export { GlobalSearch };
